export const GET_STUDENT_BALANCE_QUERY = `
  query getStudentBalance($studentId: String!) {
    getStudentBalance(studentId: $studentId) {
      amount
    }
  }
`;
